import React from 'react';
import { FiFileText, FiLink, FiVideo } from 'react-icons/fi';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';
import { PiFilePdf } from 'react-icons/pi';
import { CardIcon } from '@/components/ui/card';
import { TableCell, TableHead, TableRow, TableUser, TableUserContent, TableUserTitle } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export function CourseModuleAboutCardMaterial({ material, moduleLessons, currentModule }) {
  const fileLesson = moduleLessons?.find(item => item.id === parseInt(material?.['learning-system-item-ids']));
  const client = useClient();

  const materialLink = material?.file?.url || material?.url;

  const handleButtonClick = async () => {
    await client.mutate('route_logs', {
      uri: `/materiais/${material?.id}/${currentModule?.id}`,
      path: '/materiais/:materialId/:moduleId'
    });
  };

  const materialUrl = material?.url;
  const materialFileUrl = material?.file?.url;

  const isPdf = materialUrl?.includes('.pdf') || materialFileUrl?.includes('.pdf');
  const isFileLink = materialFileUrl && !materialFileUrl?.includes('.pdf');
  const isVideo = materialUrl?.includes('.mp4');
  const isAudio = materialUrl?.includes('.mp3');

  function MaterialIcon() {
    if (isPdf) return <PiFilePdf size={16} />;
    if (isFileLink) return <FiLink size={16} />;
    if (isVideo) return <FiVideo size={16} />;
    if (isAudio) return <FiHeadphones size={16} />;

    return <FiFileText size={16} />;
  }

  return (
    <TableRow>
      <TableHead scope="row">
        <TableUser>
          <CardIcon className="p-2">
            <MaterialIcon />
          </CardIcon>
          <TableUserContent>
            <TableUserTitle
              className="truncate text-base"
              title={material?.title}
            >
              {material?.title}
            </TableUserTitle>
          </TableUserContent>
        </TableUser>
      </TableHead>
      <TableCell>
        <Badge
          variant="bright"
          size="xs"
          square
          title={fileLesson?.body}
        >
          {fileLesson?.body}
        </Badge>
      </TableCell>
      <TableCell className="text-right">
        <Button
          variant="outline"
          size="sm"
          onClick={handleButtonClick}
          asChild
        >
          <a
            href={materialLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('button.view')}
          </a>
        </Button>
      </TableCell>
    </TableRow>
  );
}
